import angular from 'angular';
import './styles.styl';
import uiCianTypeaheadAdapter from '../../adapters/ui.bootstrap.typeahead/typeahead.module';
import './overwritten-uib-typeahead-controller';


export default angular
	.module('ui.cian.typeahead', [uiCianTypeaheadAdapter])
	.name;
